import { options_premium_TransferDomain_FooterTitle } from './FAQSecOption.locstring.json';
import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import { getUserConfiguration } from 'owa-session-store';
import { HMPlusBit } from 'owa-domain-connect';
import { isFeatureEnabled } from 'owa-feature-flags';

var lazyFullModule = new LazyModule(() => import('./lazyFAQSecOption'));
let FAQSecOption: LazyOption = createLazyOption(
    {
        key: 'FooterSection',
        titleStringKey: options_premium_TransferDomain_FooterTitle,
        searchTermsStringKey: options_premium_TransferDomain_FooterTitle,
        hideTitleInFullOptions: false,
        isHidden: () =>
            !getUserConfiguration().SessionSettings.IsPremiumConsumerMailbox ||
            !isFeatureEnabled('auth-PremiumTransferDomainTab') ||
            (getUserConfiguration().SessionSettings.PremiumAccountOffers & HMPlusBit) !== HMPlusBit,
    },
    lazyFullModule,
    m => m.default
);
export default FAQSecOption;
